import RawHtml from 'utils/miscUtils/rawHtml';
import { Label, RowTable, Value } from './SocialHandlesTableStyle';

interface RowProps {
  title: string;
  value: string | null;
  dataCy?: string;
}

const Row = ({ title, value, dataCy }: RowProps) => (
  <RowTable data-cy={dataCy}>
    <Label>{title}</Label>
    {!value && <Value> - </Value>}
    {value && <Value>{RawHtml({ html: value })}</Value>}
  </RowTable>
);

export default Row;
